import { FC } from 'react';
import { ResultStyled } from './style';

const Result: FC<{ children?: any }> = ({ children, ...restProps }) => (
  <ResultStyled {...restProps}>{children}</ResultStyled>
);

export default Result;
